import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { prefetchBreaks, prefetchAttributes } from 'Api'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchShiftsToConfirm, fetchAttributeReminderToConfirm } from 'store/actions/applicationInfo'
import { handlePushNotification } from 'store/actions/notifications'
import { fetchResourcesInformation } from 'store/actions/resources'
import { fetchSettings } from 'store/actions/settings'
import { setUserInfo } from 'store/actions/users'

const useFetchMerinioInitialData = (): void => {
  const { isAuthenticated } = useSelector((state: MStore.RootState) => state.auth)
  const { isPunchToken } = useSelector((state: MStore.RootState) => state.punchTerminal)
  const dispatch = useDispatch()
  const fetchResources = useCallback(
    async (cb?: () => void) => {
      if (!isAuthenticated) return

      if (cb) {
        if (isPunchToken) return
        return cb()
      }

      if (isPunchToken) {
        await dispatch(fetchResourcesInformation())
        await dispatch(fetchSettings())
        await dispatch(handlePushNotification(history))
      } else {
        await dispatch(setUserInfo())
        await dispatch(fetchResourcesInformation())
        await dispatch(fetchSettings())
        await dispatch(handlePushNotification(history))
        await dispatch(fetchShiftsToConfirm())
        await dispatch(fetchAttributeReminderToConfirm())
      }

      await prefetchAttributes()
      await prefetchBreaks()
    },
    [isAuthenticated, isPunchToken, dispatch]
  )

  useEffect(() => {
    fetchResources()
    if (Capacitor.isNativePlatform()) {
      App.addListener('appStateChange', async state => {
        if (state.isActive) {
          const refetchShiftsAndAttributeReminderToConfirm = () => {
            dispatch(fetchShiftsToConfirm())
            dispatch(fetchAttributeReminderToConfirm())
          }
          fetchResources(refetchShiftsAndAttributeReminderToConfirm)
        }
      })
    }
    return () => {
      if (Capacitor.isNativePlatform()) App.removeAllListeners()
    }
  }, [fetchResources, dispatch])
}

export default useFetchMerinioInitialData
